<!--
 * @Autor: lu jun jie
 * @Date: 2020-11-12
 * @Description: 利用vue重构官网
-->

<template>
    <div id="app">
        <Header v-if="!isHome" />
        <router-view />
        <Footer />
    </div>
</template>

<script>
import Header from './components/common/header'
import Footer from './components/common/footer'

export default {
    name: 'App',
    components: {
        Footer,
        Header,
    },
    data() {
        return {
            isHome: false,
        }
    },
    created() {
        fetch('//data-api.tianxie18.com/common/mourning')
            .then(res => {
                return res.json()
            })
            .then(json => {
                if (json.code == 200) {
                    document.querySelector('html').classList.add('gray')
                } else {
                    document.querySelector('html').classList.remove('gray')
                }
            })
    },
    watch: {
        // 路由监听：监听路由的变化，从而做出相应操作
        $route: {
            immediate: true, // 一旦监听到路由的变化立即执行
            handler(to, from) {
                console.log('监听路由：' + JSON.stringify(to.name))
                if (to.name == 'home') {
                    this.isHome = true
                } else {
                    this.isHome = false
                }
                if (to.name === 'privacy.html') {
                    window.location.href = '../static/privacy.html'
                }
                if (to.name === 'privacy') {
                    window.location.href = '../static/privacy.html'
                }
                if (to.name === 'device_permissions.html') {
                    window.location.href = '../static/device_permissions.html'
                }
                if (to.name === 'device_permissions') {
                    window.location.href = '../static/device_permissions.html'
                }
            },
        },
    },
}
</script>

<style>
/* @import "./components/common/css/login"; */
.gray {
    filter: grayscale(85%) saturate(80%);
    -webkit-filter: grayscale(85%) saturate(80%);
    -moz-filter: grayscale(85%) saturate(80%);
    -ms-filter: grayscale(85%) saturate(80%);
    -o-filter: grayscale(85%) saturate(80%);
    filter: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg'><filter id='grayscale'><feColorMatrix type='matrix' values='0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0'/></filter></svg>#grayscale");
    filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=.85);
    -webkit-filter: grayscale(0.85) saturate(0.8);
}
</style>



// WEBPACK FOOTER //
// src/App.vue